















export default {
    name: 'BaseCardRestaurant',
    components: {},
    props: {
        item: Object,
    },
    data() {
        return {};
    },
    methods: {},
};
